import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

import { redirect } from "../../utility/navigate";

// Подпись поля берёт цвет из темы: жёстко заданный secondary дублировал
// акцент и мешал отличить нормальное состояние от ошибки.
const styles = (theme) => ({
  formLabel: {
    "&.Mui-focused": {
      color: theme.palette.primary.main,
    },
  },
});

class AllureDockerNewFolderDialog extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  get initialState() {
    return {
      folderIdTextField: {
        value: "",
        error: false,
        errorMessage: "",
      },
    };
  }

  createFolder = () => {
    // Никакого history.replace: у папки нет собственной страницы.
    this.props
      // Регистр не трогаем: сервер его сохраняет (см. NewProjectDialog).
      .createFolder(this.state.folderIdTextField.value)
      .then(() => {
        this.resetStates();
        this.props.closeNewFolderDialog();
      })
      .catch((error) => {
        redirect(error);
        this.showFolderIdTextFieldError(error.message);
      });
  };

  handleFolderIdTextFieldChange = (event) => {
    const folderIdTextField = { ...this.state.folderIdTextField };
    folderIdTextField.value = event.target.value;
    this.setState({ folderIdTextField: folderIdTextField });
  };

  showFolderIdTextFieldError = (errorMessage) => {
    const folderIdTextField = { ...this.state.folderIdTextField };
    folderIdTextField.error = true;
    folderIdTextField.errorMessage = errorMessage;
    this.setState({ folderIdTextField: folderIdTextField });
  };

  resetStates = () => {
    this.setState(this.initialState);
  };

  handleCloseDialog = () => {
    this.props.closeNewFolderDialog();
    this.resetStates();
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleCloseDialog}
        aria-labelledby="new-folder-dialog-title"
      >
        <DialogTitle id="new-folder-dialog-title">Create a New Folder</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Folders group projects. Use slashes for nesting, e.g. <code>team/mobile</code>.
            A folder can stay empty — drag projects into it later.
          </DialogContentText>
          <TextField
            error={this.state.folderIdTextField.error}
            value={this.state.folderIdTextField.value}
            autoFocus
            margin="dense"
            id="folderId"
            label="Folder ID"
            type="string"
            onChange={this.handleFolderIdTextFieldChange}
            fullWidth
            aria-describedby="component-error-folder-id"
            InputLabelProps={{
              className: classes.formLabel,
            }}
          />
          <FormHelperText id="component-error-folder-id">
            {this.state.folderIdTextField.errorMessage}
          </FormHelperText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseDialog} variant="text">
            Cancel
          </Button>
          <Button onClick={this.createFolder} variant="contained" color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles, { withTheme: true })(AllureDockerNewFolderDialog);
